import { Routes } from '@angular/router'
import { DashboardComponent } from './modules/dashboard/dashboard.component'
import { DashboardHomeComponent } from './modules/dashboard/dashboard-home/dashboard-home.component'
import { DashboardCustomersComponent } from './modules/dashboard/dashboard-customers/dashboard-customers.component'
import { StaffListComponent } from './modules/staff/staff-list/staff-list.component'
import { TesterComponent } from './modules/tester/tester.component'
import { PostsComponent } from './modules/posts/posts.component'
import { SmartquoteEditComponent } from './modules/smartquote-edit/smartquote-edit/smartquote-edit.component'
import { SmartquotesComponent } from './modules/smartquotes/smartquotes.component'
import { unsavedChangesGuard } from '../core/guards/unsaved-changes.guard'
import { ngxPermissionsGuard } from 'ngx-permissions'
import { SmartquoteStatisticsComponent } from './modules/smartquotes/smartquote-statistics/smartquote-statistics.component'
import { IntegratedAccountsSelectorComponent } from './modules/accounts/integrated-accounts-selector/integrated-accounts-selector.component'
import { integratedAccountsGuard } from '../core/guards/integrated-accounts.guard'
import { vehicleTrackingGuard } from '../core/guards/vehicle-tracking.guard'
import { NotFoundComponent } from './modules/not-found/not-found.component'
import { DiaryHelperService } from './modules/diary/diary-helper.service'
import { OrdersComponent } from './modules/products/orders/orders.component'
import { PartsArenaDiagramComponent } from './modules/products/parts-arena-diagram/parts-arena-diagram.component'
import { DirectoryComponent } from './modules/directory/directory.component'
import { DashboardInsightsComponent } from './modules/dashboard/dashboard-insights/dashboard-insights.component'

const FORBIDDEN_ROUTE = 'forbidden'

export const SECURE_ROUTES: Routes = [
    { path: '', redirectTo: 'customers', pathMatch: 'full' },
    {
        path: 'not-found',
        component: NotFoundComponent,
        title: 'Resource Not Found',
    },
    {
        path: 'dashboard',
        component: DashboardComponent,
        children: [
            {
                path: '',
                redirectTo: 'home',
                pathMatch: 'full',
            },
            {
                path: 'home',
                component: DashboardHomeComponent,
                title: 'Dashboard',
            },
            {
                path: 'customers',
                component: DashboardCustomersComponent,
                title: 'Dashboard - Customers',
            },
            {
                path: 'insights',
                component: DashboardInsightsComponent,
                title: 'Dashboard - Insights',
            },
        ],
    },
    {
        path: 'sites',
        loadChildren: () => import('./modules/sites/routes').then((m) => m.SITE_ROUTES),
    },
    // {
    //     path: 'customers/:customerId',
    //     loadComponent: () =>
    //         import('./modules/customer-edit/customer-shell/customer-shell.component').then(
    //             (m) => m.CustomerShellComponent
    //         ),
    //     loadChildren: () => import('./modules/customer-edit/routes').then((m) => m.CUSTOMER_EDIT_ROUTES),
    //     canActivate: [authGuard],
    //     canLoad: [authGuard],
    //     title: 'Customer Details',
    // },
    {
        path: 'customers',
        loadChildren: () => import('./modules/customers/routes').then((m) => m.CUSTOMER_ROUTES),
    },
    {
        path: 'diary',
        loadComponent: () =>
            import('./modules/diary/diary-shell/diary-shell.component').then((m) => m.DiaryShellComponent),
        loadChildren: () => import('./modules/diary/routes').then((m) => m.DIARY_ROUTES),
        canLoad: [ngxPermissionsGuard],
        title: 'Diary',
        providers: [DiaryHelperService],
        data: {
            permissions: {
                only: 'DiaryManagement',
                redirectTo: FORBIDDEN_ROUTE,
            },
        },
    },
    {
        path: 'unallocated-appointments',
        loadComponent: () =>
            import('./modules/unallocated-appointments/unallocated-appointments.component').then(
                (m) => m.UnallocatedAppointmentsComponent
            ),
        title: 'Unallocated Appointments',
    },
    {
        path: 'posts',
        title: 'Posts',
        children: [
            {
                path: '',
                redirectTo: 'all',
                pathMatch: 'full',
            },
            {
                path: 'all',
                component: PostsComponent,
                title: 'Posts',
                children: [],
            },
            {
                path: ':postId',
                loadComponent: () =>
                    import('./modules/post/post-shell/post-shell.component').then((m) => m.PostShellComponent),
                loadChildren: () => import('./modules/post/routes').then((m) => m.POST_ROUTES),
                title: 'Process Post',
            },
        ],
    },
    {
        path: 'ssp',
        loadChildren: () => import('./modules/ssp/routes').then((m) => m.SSP_ROUTES),
        canActivate: [ngxPermissionsGuard],
        canLoad: [ngxPermissionsGuard],
        data: {
            permissions: {
                only: 'SSP',
                redirectTo: FORBIDDEN_ROUTE,
            },
        },
    },
    {
        path: 'staff',
        title: 'staff',
        children: [
            {
                path: '',
                component: StaffListComponent,
                title: 'Staff',
            },
            {
                path: ':staffId',
                // loadComponent: () =>
                //     import('./modules/staff-edit/staff-shell/staff-shell.component').then((m) => m.StaffShellComponent),
                loadChildren: () => import('./modules/staff-edit/routes').then((m) => m.STAFF_EDIT_ROUTES),
                // title: 'Staff Details',
            },
        ],
    },
    {
        path: 'appliance-reminders',
        loadChildren: () => import('./modules/appliance-reminders/routes').then((m) => m.APPLIANCE_REMINDERS_ROUTES),
    },
    {
        path: 'directory',
        component: DirectoryComponent,
        title: 'Directory',
    },
    {
        path: 'smartquotes',
        component: SmartquotesComponent,
        title: 'SmartQuotes',
    },
    {
        path: 'smartquotes/statistics',
        component: SmartquoteStatisticsComponent,
        title: 'SmartQuotes',
    },
    {
        path: 'smartquote/:smartquoteId',
        component: SmartquoteEditComponent,
        canDeactivate: [unsavedChangesGuard],
        title: 'Smart Quote',
    },
    {
        path: 'smartquote',
        component: SmartquoteEditComponent,
        canDeactivate: [unsavedChangesGuard],
        title: 'Smart Quote',
    },
    {
        path: 'wolseley-order',
        loadChildren: () => import('./modules/wolseley/routes').then((m) => m.WOLSELEY_ROUTES),
        canActivate: [ngxPermissionsGuard],
        canLoad: [ngxPermissionsGuard],
        data: {
            permissions: {
                only: 'Wolseley',
                redirectTo: FORBIDDEN_ROUTE,
            },
        },
    },
    {
        path: 'reports',
        loadChildren: () => import('./modules/reports/routes').then((m) => m.REPORTS_ROUTES),
    },
    {
        path: 'wildix',
        loadChildren: () => import('./modules/wildix/routes').then((m) => m.WILDIX_ROUTES),
        canLoad: [ngxPermissionsGuard],
        data: {
            permissions: {
                only: 'Wildix',
                redirectTo: FORBIDDEN_ROUTE,
            },
        },
    },
    {
        path: 'appointment/:appointmentId',
        loadComponent: () =>
            import('./modules/appointments/appointment-shell/appointment-shell.component').then(
                (m) => m.AppointmentShellComponent
            ),
        loadChildren: () => import('./modules/appointments/routes').then((m) => m.APPOINTMENT_ROUTES),
        title: 'Appointment Details',
    },
    {
        path: 'tester',
        component: TesterComponent,
        title: 'Tester',
    },
    {
        path: 'orders',
        component: OrdersComponent,
        title: 'Orders',
    },
    {
        path: 'finance-calculator',
        loadComponent: () =>
            import('./modules/finance-calculator/finance-calculator.component').then(
                (m) => m.FinanceCalculatorComponent
            ),
        title: 'Finance Calculator',
    },

    {
        path: 'estimates',
        loadChildren: () => import('./modules/estimates/routes').then((m) => m.ESTIMATE_ROUTES),
    },
    {
        path: 'account',
        loadChildren: () => import('./modules/me/routes').then((m) => m.ME_ROUTES),
    },
    {
        path: 'accounts-integrations/selector',
        component: IntegratedAccountsSelectorComponent,
        title: 'Accounts Integration',
    },
    {
        path: 'accounts-integration/connectors',
        loadChildren: () =>
            import('./modules/accounts/integrated-accounts-connectors/routes').then(
                (m) => m.INTEGRATED_ACCOUNTS_CONNECTOR_ROUTES
            ),
    },
    {
        path: 'accounts-integration',
        loadChildren: () =>
            import('./modules/accounts/integrated-accounts/routes').then((m) => m.INTEGRATED_ACCOUNTS_ROUTES),
        canActivate: [integratedAccountsGuard],
        canLoad: [integratedAccountsGuard],
        title: 'Accounts Integration',
    },
    {
        path: 'surefire-accounts',
        loadChildren: () =>
            import('./modules/accounts/surefire-accounts/routes').then((m) => m.SUREFIRE_ACCOUNTS_ROUTES),
        title: 'Accounts',
    },
    {
        path: 'payments',
        loadComponent: () =>
            import('./modules/accounts/payments/payments/payments.component').then((m) => m.PaymentsComponent),
        loadChildren: () => import('./modules/accounts/payments/routes').then((m) => m.PAYMENTS_ROUTES),
        title: 'Payments',
    },
    {
        path: 'inventory',
        loadComponent: () =>
            import('./modules/inventory/inventory-shell/inventory-shell.component').then(
                (m) => m.InventoryShellComponent
            ),
        loadChildren: () => import('./modules/inventory/routes').then((m) => m.INVENTORY_ROUTES),
        canActivate: [ngxPermissionsGuard],
        canLoad: [ngxPermissionsGuard],
        title: 'Inventory',
        data: {
            permissions: {
                only: 'StockControl',
                redirectTo: FORBIDDEN_ROUTE,
            },
        },
    },
    {
        path: 'air-quotes',
        loadChildren: () => import('./modules/air-quotes/routes').then((m) => m.AIRQUOTE_ROUTES),
        canActivate: [ngxPermissionsGuard],
        canLoad: [ngxPermissionsGuard],
        data: {
            permissions: {
                only: 'AirQuote',
                redirectTo: FORBIDDEN_ROUTE,
            },
        },
    },
    {
        path: 'vehicle-tracking',
        loadComponent: () =>
            import('./modules/quartix/quartix-shell/quartix-shell.component').then((m) => m.QuartixShellComponent),
        loadChildren: () => import('./modules/quartix/routes').then((m) => m.QUARTIX_ROUTES),
        canActivate: [vehicleTrackingGuard],
    },

    {
        path: 'staff-tracker',
        loadComponent: () =>
            import('./modules/staff/staff-mobile-tracking/staff-mobile-tracking.component').then(
                (m) => m.StaffMobileTrackingComponent
            ),
        title: 'Staff Tracker',
    },

    {
        path: 'admin',
        loadComponent: () =>
            import('./modules/admin/admin-shell/admin-shell.component').then((m) => m.AdminShellComponent),
        loadChildren: () => import('./modules/admin/routes').then((m) => m.ADMIN_ROUTES),
        title: 'Admin',
    },
    {
        path: 'emails',
        loadComponent: () => import('./modules/emails/emails.component').then((m) => m.EmailsComponent),
        title: 'Support - Emails',
    },
    {
        path: 'sms',
        loadComponent: () => import('./modules/sms/sms.component').then((m) => m.SmsComponent),
        title: 'Sent SMS',
    },

    {
        path: 'products/parts-arena',
        component: PartsArenaDiagramComponent,
        title: 'Parts Arena Diagram',
    },
    {
        path: 'help/contact-support',
        loadComponent: () =>
            import('./modules/help/contact-support/contact-support.component').then((m) => m.ContactSupportComponent),
        title: 'Contact Support',
    },
    {
        path: 'release-notes',
        loadChildren: () => import('./modules/release-notes/routes').then((m) => m.RELEASE_NOTES_ROUTES),
        title: 'Release Notes',
    },
    {
        path: 'notices',
        loadChildren: () => import('./modules/notices/routes').then((m) => m.NOTICES_ROUTES),
        title: 'Notices',
    },
    {
        path: 'support',
        loadComponent: () =>
            import('./modules/support/support-shell/support-shell.component').then((m) => m.SupportShellComponent),
        loadChildren: () => import('./modules/support/routes').then((m) => m.SUPPORT_ROUTES),
        title: 'Admin',
        data: {
            permissions: {
                only: 'SUPPORT',
                redirectTo: FORBIDDEN_ROUTE,
            },
        },
    },
    {
        path: 'billing',
        loadComponent: () =>
            import('./modules/billing/billing-shell/billing-shell.component').then((m) => m.BillingShellComponent),
        loadChildren: () => import('./modules/billing/routes').then((m) => m.BILLING_ROUTES),
        title: 'Billing',
        data: {
            permissions: {
                only: 'SUPPORT',
                redirectTo: FORBIDDEN_ROUTE,
            },
        },
    },
]
